import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerUpRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-up-right"><path d="M3.75 19V8.5H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 12.5L20.25 8.5L16.25 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerUpRight;
